<template>
    <ul class="list-unstyled" v-if=messages>
        <li class="alert" v-for="message in messages"
        :class="message.type">
            {{message.message}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </li>
    </ul>

</template>

<script>
    export default {
        computed: {
            messages(){
                return this.$store.state.messages;
            }
        }
    }
</script>
